@if (assets.length === 0 && dataFetched && !keyword) {
  <pp-no-assets-created-yet-page
    [ppFleetId]="ppFleetId"
  ></pp-no-assets-created-yet-page>
}

@if (assets.length === 0 && dataFetched && keyword) {
  <pp-no-asset-search-result-page
  ></pp-no-asset-search-result-page>
}

<pp-fleet-assets-page [ppAssets]="assets"></pp-fleet-assets-page>
